import React, { useState } from 'react'
import MealList from '../components/MealList'


import SearchForm from '../components/SearchForm';


export default function Home({handleSubmit}) {
    const [loading, setLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState("chicken");
    const [ allMeals, setMeals] = useState([]);

    React.useEffect(() => {
        setLoading(true);
        async function getMeal() {
            try {
                const response = await fetch(`https://www.themealdb.com/api/json/v1/1/search.php?s=${searchTerm}`);
                const data = await response.json();
                const { meals } = data;

                if(meals){
                    const newMeal = meals.map(item => {
                        const {
                            idMeal,
                            strMealThumb,
                            strMeal,
                            strInstructions,
                            strCategory,
                            strArea
                        } = item;

                        return {
                            id: idMeal,
                            name: strMeal,
                            image: strMealThumb,
                            info: strInstructions,
                            cate: strCategory,
                            area: strArea
                          };     
                    });
                    setMeals(newMeal);
                } else {
                    setMeals([]);
                }
            }  catch (error) {
                console.log(error);
              }
              setLoading(false);
        }
        getMeal();
        
    }, [searchTerm])
    
    return (
        <main className="bg-purple-900 mt-20 mx-auto sm:w-4/5 h-full py-1 flex flex-col rounded border border-lg shadow-xl ">
            <SearchForm className="flex-1 " 
                setSearchTerm={setSearchTerm} handleSubmit={handleSubmit} />
             
            <MealList loading={loading} allMeals={allMeals} />
        </main>
    )
}
